import { IconButton, Tooltip } from "@mui/material";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { useThemeMode } from "../context/ThemeContext";

export default function ThemeToggle() {
  const { effectiveMode, toggleMode, mode } = useThemeMode();
  const next = effectiveMode === "dark" ? "light" : "dark";
  const disabled = effectiveMode !== mode; // forced dark pages disable toggle
  return (
    <Tooltip title={disabled ? "Theme fixed on this page" : `Switch to ${next} mode`}>
      <span>
        <IconButton onClick={toggleMode} disabled={disabled} color="inherit" aria-label="Toggle theme">
          {effectiveMode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
        </IconButton>
      </span>
    </Tooltip>
  );
}

